import React, { useEffect, useState, useContext } from "react";
import "./QtestAnswerComponent.scss";
import { BEURL, S3URL } from "../../../api/BaseUrl";
import QuizMediaComponent from "../../quizComponent/quizMediaComponent/quizMediaComponent/QuizMediaComponent";
import QuizAnswerMTF from "../../quizComponent/quizAnswerComponent/QuizAnswerMTF";
import QuizArrangeDragArrange from "../../quizComponent/quizAnswerComponent/QuizAnswerDragArrange";
import { MdSportsScore } from "react-icons/md";
import WarningComponent from "../../../shared/warningComponent/WarningComponent";
import Context from "../../../context/Context";
import apiEndpoints from "../../../api/EndPoints";
import axios from "axios";

import CircularProgressComponent from "../../../shared/circularProgressComponent/CircularProgressComponent";

const QtestAnswerSubComponent = ({ answer, title }) => {
  const { correctAnswer, imageName, s3AnswerImageName, answerContent, qtestType, questionType, playerScore, playerRunningScore } =
    answer || {};
  return (
    <div className="qtestanswer">
      <div className="qtestanswer__title">
        <p className="qtestanswer__titleText">{title}</p>
      </div>
      <p className="qtestanswer__curScoreText">You got {playerScore} points</p>
      <div className="qtestanswer__scoreBanner">
            TOTAL POINTS : {playerRunningScore.totalScore}
      </div>
      
      {questionType != "MTF" && questionType != "DND" && (
        <div
          className="qtestanswer__image"
          style={{marginBottom: "1rem"}}
          // style={{ marginBottom: answerContent == "None" ? "30px" : "0px" }}
        >
          <QuizMediaComponent
            mediaUrl={
              S3URL +
              (qtestType == "IB" ? "generated/" : "readymade/") +
              (s3AnswerImageName?s3AnswerImageName:imageName) // Check for answer image else display question image
            }
          />
        </div>
      )}
      
      {questionType == "MTF" && <QuizAnswerMTF correctAnswer={correctAnswer} />}
      {questionType == "DND" && (
        <QuizArrangeDragArrange correctAnswer={correctAnswer} />
      )}

      {answerContent != "None" && (
        <div
          className={
            questionType == "CNT"
              ? "qtestanswer__info qtestanswer__connect"
              : "qtestanswer__info"
          }
        >
          <p className="qtestanswer__infoText">{answerContent}</p>
        </div>
      )}
    </div>
  );
};

const QtestResultSubComponent = ({ rank, correctAnswers, totalNoOfQuestions, totalScore, showScoresFlag, retakeFlag, retakeData, handleRetakeRequest }) => {
  const progressPercentage = (correctAnswers / totalNoOfQuestions) * 100;
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const finalOffset = circumference - (progressPercentage / 100) * circumference;
  const [retakeModalOpen, setRetakeModalOpen] = useState(false);
  const { setLoadingDisplayFlag, setNotificationType, setNotificationMessage, setNotificationDisplayFlag } = useContext(Context);

  const handleRetakeQuiz = () => {
    setRetakeModalOpen(true)
  };

  const setAlert = (type, message) => {
    setNotificationType(type);
    setNotificationMessage(message);
    setNotificationDisplayFlag(true);
  };

  const handleConfirmRetake = () => {
    setRetakeModalOpen(false);
    setLoadingDisplayFlag(true);
    const url = BEURL + apiEndpoints.deleteQtestPlayerAnswer;
    const data = {
      qtestId: retakeData.qtestId,
      playerId: retakeData.playerId
    };
    
    axios.post(url, data)
      .then((res) => {
        if (res.status === 200) {
          setAlert("success", res.data + " You will be redirected in 3 seconds");
          setTimeout(() => {
            setLoadingDisplayFlag(false);
            handleRetakeRequest();
          }, 3000);
        } else {
          setAlert("error", res.data);
          setLoadingDisplayFlag(false);
        }
      })
      .catch((err) => {
        setAlert("error", err.response?.data + ". Failed to delete player records!");
        setLoadingDisplayFlag(false);
      });
  };
  
  return (
    <>
      <div className="qtestresult">
        <img className="qtestresult__resultTopImage" src="/images/qTFriends.png" alt="qTFriends" />
        <div className="qtestresult__title qtestresult__resultTitle">
          <p className="qtestresult__titleText">
            Thank You. You have successfully completed your Quiz!
          </p>
        </div>
        {showScoresFlag ? 
          (<div className="qtestresult__resultBanner">
            <div className="qtestresult__resultContent">
              <div className="qtestresult__progressContainer">
                <CircularProgressComponent
                  correctAnswers={correctAnswers}
                  totalNoOfQuestions={totalNoOfQuestions}
                />
              </div>
              <div className="qtestresult__scoreContainer">
                <p className="qtestresult__scoreText">Your Total Score: {totalScore}</p>
                <p className="qtestresult__rankText">Your Rank: {rank}</p>
                {/* Retake Quiz Button */}
                {retakeFlag && <button 
                  className="qtestresult__retakeButton"
                  onClick={handleRetakeQuiz}
                >
                  Retake Quiz
                </button>}
              </div>
            </div>
          </div>) : ""
        }
      </div>
      <WarningComponent
        buttonText="Confirm"
        modalOpen={retakeModalOpen}
        setModalOpen={setRetakeModalOpen}
        handleClick={handleConfirmRetake}
      >
        <p style={{fontWeight: 600, fontSize: "2rem", maxWidth: "50rem"}}>
          You have already attempted this quiz. Your previous score will be overwritten. Do you wish to continue?
        </p>
        <p>
          <span style={{ fontWeight: 600, color: "red", fontStyle: "italic" }}>
            This action is irreversible.
          </span>{" "}
          Click on the button below if you wish to proceed.
        </p>
      </WarningComponent>
    </>
  );
};

const QtestAnswerComponent = ({
  answer,
  selectedAnswer,
  rank,
  correctAnswers,
  totalNoOfQuestions,
  totalScore,
  showThankYouPageFlag,
  showScoresFlag,
  retakeFlag = false,
  retakeData = {},
  handleRetakeRequest = () => {}
}) => {
  const { correctAnswer, questionType } = answer || {};
  let title;
  let displayAnswer = "'";
  let same = false;

  // Check the answer and form title and displayAnswer only if correctAnswer exists
  if (correctAnswer) {
    if (questionType == "DND" || questionType == "MTF") {
      const correctAnswerList = eval(correctAnswer);
      if (questionType == "MTF") {
        if (
          JSON.stringify(correctAnswerList[1]) == JSON.stringify(selectedAnswer)
        ) {
          same = true;
        }
      } else {
        if (
          JSON.stringify(correctAnswerList) == JSON.stringify(selectedAnswer)
        ) {
          same = true;
        }
      }
      if (same) {
        title = `Good Job! the Correct Answer is`;
      } else {
        title = `Uh-Oh. the Correct Answer is`;
      }
    } else {
      const answers = eval(correctAnswer).map((ans) => ans.toLowerCase());
      displayAnswer = eval(correctAnswer);
      same = answers.includes(selectedAnswer.toLowerCase()) ? true : false;
      if (same) {
        title = `Good Job! '${displayAnswer}' is the Correct Answer!`;
      } else {
        title = `Uh-Oh. '${displayAnswer}' is the Correct Answer!`;
      }
    }
  }

  useEffect(() => {
    document.getElementById("main").scrollTo(0, 0);
  }, []);

  return (
    <>
      {showThankYouPageFlag ? (
        <QtestResultSubComponent rank={rank} correctAnswers={correctAnswers} totalNoOfQuestions={totalNoOfQuestions} totalScore={totalScore} showScoresFlag={showScoresFlag} retakeFlag={retakeFlag} retakeData={retakeData} handleRetakeRequest={handleRetakeRequest} />
      ) : (
        <QtestAnswerSubComponent answer={answer} title={title} />
      )}
    </>
  );
};

export default QtestAnswerComponent;
